import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchVoucherTerms = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group-voucher-terms/${subscriberGroupId}`);
    return res?.data?.data?.voucher_terms_text ?? "";
};

export const useVoucherTerms = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["voucherTerms", subscriberGroupId],
        queryFn: () => fetchVoucherTerms(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        voucherTerms: data ?? "",
        isLoading,
    };
};
